import {
  Application,
  ApplicationChild,
  GetProductsToBeAssignedResponse,
  StringOrNull,
} from '@schooly/api';
import { CreateChildForm, CreateParentForm } from '@schooly/components/applications';
import { CreateCustomField } from '@schooly/components/applications';
import { createContext, Dispatch, SetStateAction } from 'react';

import { AssignedProductUpdate } from '../../pages/ProfileModal/tabs/ProfileModalPayers/StudentProductsModal/StudentProductsModalContent';
import { ApplicationAction } from '../../redux/slices/applicationSlice';

export interface ApplicationRouteState {
  type: 'application';
  actionType: ApplicationAction;
  parents: CreateParentForm[];
}
export interface ApplyStudentsForm {
  children: Array<
    {
      childId: string;
      relationId: StringOrNull;
      school_year_id?: string;
      half_day?: boolean;
      house_property_id?: string;
      age_group_property_id?: string;
      statuses: Array<{
        school_property_id: string;
        applies_from: string;
        applies_to: string;
        formId?: string;
      }>;
      product_assignments: AssignedProductUpdate[];
    } & Pick<ApplicationChild, 'given_name' | 'last_name' | 'preferred_start_date'>
  >;
}

export interface RejectApplicationForm {
  share_with_parent: boolean;
  rejection_reason: string;
}
export interface CreateApplicationProps {
  children: CreateChildForm[];
  parents: CreateParentForm[];
  generalCustomFields: CreateCustomField[];
}

export interface ApplicationContextProps {
  application?: Application;
  fetching: boolean;
  converting: boolean;
  applicationId?: string;
  handleApplyStudents: (formData: ApplyStudentsForm) => Promise<string | undefined>;
  canEdit: boolean;
  canView: boolean;
  updateApplicationChildNotes: (child: ApplicationChild) => Promise<string | undefined>;
  updating: Record<string, boolean>;
  rejectApplication: (data: RejectApplicationForm) => Promise<string | undefined>;
  isApplicationManager: boolean;
  createApplication: (data: CreateApplicationProps) => Promise<string | undefined>;
  updateApplication: (data: CreateApplicationProps) => Promise<boolean | undefined>;
  getProductAssignments: (
    formData: ApplyStudentsForm,
  ) => Promise<GetProductsToBeAssignedResponse | undefined>;
  pendingParents: CreateParentForm[];
  setPendingParents: Dispatch<SetStateAction<CreateParentForm[]>>;
  addParentModal: { isOpen: boolean; onOpen: () => void; onClose: () => void };
}

export const ApplicationContext = createContext<ApplicationContextProps>({
  application: undefined,
  fetching: false,
  converting: false,
  applicationId: undefined,
  handleApplyStudents: async () => undefined,
  canEdit: false,
  canView: false,
  updateApplicationChildNotes: async () => undefined,
  updating: {},
  rejectApplication: async () => undefined,
  isApplicationManager: false,
  createApplication: async () => undefined,
  updateApplication: async () => undefined,
  getProductAssignments: async () => undefined,
  pendingParents: [],
  setPendingParents: () => {},
  addParentModal: { isOpen: false, onOpen: () => {}, onClose: () => {} },
});

ApplicationContext.displayName = 'ApplicationContext';
